import React from "react"
import PropTypes from "prop-types"
import { Flex } from "antd"
import { useTranslation } from "react-i18next"
import MultiSelect from "components/common/MultiSelect"
import FilterChips from "ui/FilterChips"
import styles from "./index.module.css"

const EquipmentFilters = ({ selectedCategories, onCategoryChange, categoryOptions = [] }) => {
  const { t } = useTranslation()

  return (
    <Flex vertical gap={12}>
      <MultiSelect
        value={selectedCategories}
        onChange={onCategoryChange}
        options={categoryOptions}
        placeholder={t("booking.equipment.category_filter")}
        dropdownClassName={styles.categoryDropdown}
        t={t}
        style={{ minWidth: "200px", maxWidth: "240px" }}
      />

      <FilterChips selectedValues={selectedCategories} options={categoryOptions} onChange={onCategoryChange} />
    </Flex>
  )
}

EquipmentFilters.propTypes = {
  selectedCategories: PropTypes.arrayOf(PropTypes.string).isRequired,
  onCategoryChange: PropTypes.func.isRequired,
  categoryOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired
}

export default EquipmentFilters
